import {
    GET_JOB_PACK,
    GET_NEW_JOB_PACK_UID,
    GET_JOB_TYPES,
    SET_JOB_TYPE,
    GET_ALL_USERS,
    GET_ALL_TOOLBOXES,
    GET_ALL_QUALIFICATIONS,
    SET_JOB_PACK,
    GET_TOTAL
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    users: false,
    jobPack: false,
    newJobPackUID: false,
    allQualifications: false,
    toolboxes: false,
    jobTypes: false,
    selectedJobType: "new_job_pack",
    jobpackCount: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_TOTAL.REQUEST: {
            return { ...state, requesting: true, jobpackCount: false };
        }
        case GET_TOTAL.FAIL: {
            return { ...state, requesting: false, jobpackCount: false };
        }
        case GET_TOTAL.SUCCESS: {
            return { ...state, requesting: false, jobpackCount: action.payload };
        }
        case SET_JOB_PACK.REQUEST: {
            return {...state,requesting:true}
        }
        case GET_ALL_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_ALL_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_ALL_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case GET_ALL_TOOLBOXES.REQUEST: {
            return { ...state, requesting: true, toolboxes: false };
        }
        case GET_ALL_TOOLBOXES.FAIL: {
            return { ...state, requesting: false, toolboxes: false };
        }
        case GET_ALL_TOOLBOXES.SUCCESS: {
            return { ...state, requesting: false, toolboxes: action.payload };
        }
        case GET_JOB_PACK.REQUEST: {
            return { ...state, requesting: true, jobPack: false };
        }
        case GET_JOB_PACK.FAIL: {
            return { ...state, requesting: false, jobPack: false };
        }
        case GET_JOB_PACK.SUCCESS: {
            return { ...state, requesting: false, jobPack: action.payload };
        }
        case GET_JOB_TYPES.REQUEST: {
            return { ...state, requesting: true, jobTypes: false };
        }
        case GET_JOB_TYPES.FAIL: {
            return { ...state, requesting: false, jobTypes: false };
        }
        case GET_JOB_TYPES.SUCCESS: {
            return { ...state, requesting: false, jobTypes: action.payload };
        }
        case GET_NEW_JOB_PACK_UID.FAIL: {
            return { ...state, requesting: false, newJobPackUID: false };
        }
        case GET_NEW_JOB_PACK_UID.REQUEST: {
            return { ...state, requesting: true, newJobPackUID: false };
        }
        case GET_ALL_QUALIFICATIONS.REQUEST: {
            return { ...state, requesting: true, allQualifications: false };
        }
        case GET_ALL_QUALIFICATIONS.FAIL: {
            return { ...state, requesting: false, allQualifications: false };
        }
        case GET_ALL_QUALIFICATIONS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                allQualifications: action.payload,
            };
        }
        case SET_JOB_TYPE: {
            return {
                ...state,
                requesting: false,
                selectedJobType: action.payload,
            };
        }
        case GET_NEW_JOB_PACK_UID.SUCCESS: {
            return {
                ...state,
                requesting: false,
                newJobPackUID: action.payload,
            };
        }

        default: {
            return { ...state };
        }
    }
};
